import React from "react";
import css from "./MeetingCard.module.css";

export const MeetingCard = ({
  title,
  type,
  date,
  status,
  participants,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={`${css.meetingCard} ${
        type === "health" ? css.health : css.consultation
      }`}
    >
      <h3 className={css.meetingCardTitle}>{title}</h3>
      <p className={css.meetingCardDate}>
        <strong>Data:</strong>{" "}
        {/* {new Date(m.scheduleFor).toLocaleString("pt-BR")} */}
        {date}
      </p>
      <div className={css.meetingDetails}>
        <p>
          <strong>Status:</strong> {status}
        </p>
        <p>
          <strong>Participantes ({participants.length}):</strong>{" "}
          {participants[0]}, {participants[1]}
        </p>
      </div>
      {children}
    </div>
  );
};
